<script lang="ts">
  import GenericErrorPage from "./GenericErrorPage.svelte";
  import { sessionStore } from "../../lib/stores/session";
  import Typography from "../Typography.svelte";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import { getCopy } from "../../lib/stores/copy";
  import Youtube from "../Youtube.svelte";

  export let currentRoute: { name: string; path: string };

  $: copy = $getCopy("invalidEntry") as Record<string, string>;
  $: sensibleClientError = copy.genericInvalidEntryCopy;
  $: error = $sessionStore.foojiData?.campaign_user?.last_entry_validation_error;
  $: {
    if (error && error.length === 1) {
      const code = error[0];

      const errorMap: Record<string, string> = {
        NO_EMAIL_TO_CHECK_PATTERN: copy.invalidEmailCopy,
        EMAIL_PATTERN_MISMATCH: copy.invalidEmailCopy,
        ENTRY_TOKEN_USED: copy.usedTokenCopy,
        ENTRY_TOKEN_INVALID: copy.invalidTokenCopy
      };

      sensibleClientError = errorMap[code] ? errorMap[code] : copy.genericInvalidEntryCopy;
    }
  }
</script>

<GenericErrorPage {currentRoute}>
  <svelte:fragment slot="error">
    {#if error}
      <div class="flex w-full justify-center lg:justify-start">
        <Typography
          mobile={TypographyType.Body1Medium}
          desktop={TypographyType.Headline2}
          --font-color="var(--subheader-font-color)">
          <h2 class="mt-24 text-[--color-red-50]">{sensibleClientError}</h2>
        </Typography>
      </div>
    {/if}
    <Youtube videoId={copy.videoId} />
  </svelte:fragment>
</GenericErrorPage>
